export const travelApp = {
    slug: 'travel-app',
    no: '05',
    type: 'external',
    title: 'Travel App For Visitors',
    category: 'Mobile App',
    sourceUrl: 'https://himanshutanty.com/portfolio/travel-app/',
    cover: '/api/files/8e5d19d7-40f3-48d6-aac5-3ef1cb977bfd',
    external: {
        label: 'View Project on Behance',
        href: 'https://www.behance.net/gallery/106799769/Travel-App',
    },
    next: { slug: 'graphic-designs', title: 'Graphic Designs' },
};
